import { sanitizeSettings } from './settings'
import type { GameSettings, Locale, Preset, ScoreEntry } from './types'

const SETTINGS_KEY = 'snake:settings:v1'
const PRESETS_KEY = 'snake:presets:v1'
const PLAYER_KEY = 'snake:player:v1'
const LOCALE_KEY = 'snake:locale:v1'
const BEST_KEY = 'snake:best:v1'
const PENDING_KEY = 'snake:pendingScores:v1'

function read<T>(key: string, fallback: T): T {
  try {
    const raw = localStorage.getItem(key)
    return raw ? JSON.parse(raw) as T : fallback
  } catch {
    return fallback
  }
}

function write(key: string, value: unknown) {
  try { localStorage.setItem(key, JSON.stringify(value)) } catch { /* private mode */ }
}

export const loadSettings = (fallback: GameSettings) => sanitizeSettings(read(SETTINGS_KEY, fallback))
export const saveSettings = (settings: GameSettings) => write(SETTINGS_KEY, settings)
export const loadPresets = (): Preset[] => read<unknown[]>(PRESETS_KEY, []).filter((item): item is Preset => Boolean(item && typeof item === 'object' && 'name' in item))
export const savePresets = (presets: Preset[]) => write(PRESETS_KEY, presets.slice(0, 20))
export const loadPlayer = () => read(PLAYER_KEY, '')
export const savePlayer = (name: string) => write(PLAYER_KEY, name)
export const loadLocale = (): Locale | null => {
  const locale = read<string | null>(LOCALE_KEY, null)
  return locale === 'ca' || locale === 'es' || locale === 'en' ? locale : null
}
export const saveLocale = (locale: Locale) => write(LOCALE_KEY, locale)
export const loadBest = () => Math.max(0, read(BEST_KEY, 0))
export const saveBest = (score: number) => { if (score > loadBest()) write(BEST_KEY, score) }
export const loadPendingScores = (): ScoreEntry[] => read(PENDING_KEY, [])
export const savePendingScores = (scores: ScoreEntry[]) => write(PENDING_KEY, scores.slice(-20))
